import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import userRoutes from '../../../components/user/userRoutes';

const logout = createAsyncThunk(
  'thunk/user/logout',
  async (arg, thunkAPI) => {
    const response = await apiFetch(userRoutes.api.logout, {});
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default logout;
